import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { Database } from '@core/interfaces/database.types';

@Injectable({
  providedIn: 'root',
})
export class Supabase {
  public readonly client: SupabaseClient<Database>;

  constructor() {
    this.client = createClient(environment.supabaseUrl, environment.supabaseAnonKey);
  }
}
